// extracted by mini-css-extract-plugin
export default {"coursesList":"CoursesList_coursesList__ggqFj","rowItem":"CoursesList_rowItem__zLgvk","cardItem":"CoursesList_cardItem__NR-wb"};